export const permissionTranslations = {
  "view-publicity": "Ver Publicidad",
  "manage-clients": "Gestionar Clientes",
  "manage-technician": "Gestionar Técnicos",
  "manage-partners": "Gestionar Técnicos Partner",
  "access-dashboard": "Acceso al Panel",
  "manage-users-roles": "Gestionar Usuarios y Roles",
  "manage-subcription": "Gestionar Suscripciones",
  "manage-categories": "gestionar categorias",
  "view-manage-actividade":"Gestionar Actividades",
  "reports":"Reportes"
  // Puedes seguir agregando aquí...
};
